<template>
	<v-menu
		ref="menuConfig"
		bottom
		offset-y
		right
		min-width="550"
		max-width="550"
		content-class="container-notification-menu-header"
		:close-on-content-click="false"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				icon
				dark
				small
				color="#959595"
				class="mr-2"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon dark>mdi-cog-outline</v-icon>
			</v-btn>
		</template>
		<div class="white" style="position: relative;">
			<div dense class="px-2 py-1" style="background: #959595;">
				<p class="caption mb-0 font-weight-bold white--text">Configuración Contratos</p>
			</div>
			<div class="pa-0">
				<v-tabs
					v-model="tab"
					background-color="#524D4D"
					grow
					dark
					height="40"
				>
					<v-tab>Columnas Tabla</v-tab>
					<v-tab>
						<div class="d-flex align-center">
							<p class="mb-0 font-weight-bold body-2">Prefijos y Títulos</p>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-icon small dark
												v-bind="attrs"
												v-on="on"
												class="ml-2">mdi-information</v-icon>
								</template>
								<span>En esta sección podrás administrar los tipos de contratos con los que tu empresa trabajará y que aparecerán en la tabla de correlativos</span>
							</v-tooltip>
						</div>
					</v-tab>
					<!-- <v-tab>Títulos</v-tab> -->
				</v-tabs>
				<v-tabs-items v-model="tab">
					<v-tab-item>
						<div class="pa-2 white" v-if="contracts_header_columns">
							<p class="mb-0 caption font-weight-bold">Selecciona las columnas a visualizar</p>
							<v-checkbox v-model="contracts_header_columns.serial" color="black" label="Nº" hide-details dense @change="changeColumns"></v-checkbox>
							<v-checkbox v-model="contracts_header_columns.client" color="black" label="Cliente" hide-details dense @change="changeColumns"></v-checkbox>
							<v-checkbox v-model="contracts_header_columns.details" color="black" label="Detalle" hide-details dense @change="changeColumns"></v-checkbox>
							<v-checkbox v-model="contracts_header_columns.address" color="black" label="Dirección Proyecto" hide-details dense @change="changeColumns"></v-checkbox>
							<v-checkbox v-model="contracts_header_columns.status" color="black" label="Estado" hide-details dense @change="changeColumns"></v-checkbox>
							<v-checkbox v-model="contracts_header_columns.actions" color="black" label="Acciones" hide-details dense @change="changeColumns"></v-checkbox>
						</div>
					</v-tab-item>
					<!-- <v-tab-item>
						<div class="pa-4">
							<div class="d-flex align-center">
								<v-text-field
									v-model="baseSerial"
									:loading="showLoading"
									outlined
									dense
									hide-details
									item-text="name"
									item-value="id"
									label="Número Base Para Correlativos"
									class="custom-height-search custom-height-calendar mt-2"
									color="#524D4D"
									@keypress="isNumberKey"
								></v-text-field>
							</div>
						</div>
					</v-tab-item> -->
					<v-tab-item>
						<div class="pa-4">
							<p class="mb-0 caption text-center" style="color: #524D4D">En esta sección podrás administrar los tipos de contrato con los que tu empresa trabajará y que aparecerán en la tabla de correlativos</p>
							<div class="d-flex flex-row align-center justify-space-between my-2 mb-0 px-2">
								<p class="mb-0 font-weight-bold body-2" style="color: #524D4D">Prefijos para Contratos</p>
								<!-- <div class="d-flex align-center">
									<p class="mb-0 font-weight-bold body-2" style="color: #524D4D">Prefijos para Presupuesto</p>
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-icon small
														v-bind="attrs"
														v-on="on"
														class="ml-2">mdi-information</v-icon>
										</template>
										<span>En esta sección podrás administrar los tipos de presupuesto con los que tu empresa trabajará</span>
									</v-tooltip>
									<p class="mb-0 caption" style="color: #524D4D">En esta sección podrás administrar los tipos de presupuesto con los que tu empresa trabajará</p>
								</div> -->
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn icon color="grey" class="mr-3"
													v-bind="attrs"
													v-on="on"
													small
													@click="setBudgetPrefix(null)">
											<v-icon>mdi-plus</v-icon>
										</v-btn>
									</template>
									<span>Nuevo prefijo para Contrato</span>
								</v-tooltip>
							</div>
							<v-divider class="my-2"></v-divider>
							<PrefixListingMenu :type="'contract'" />
						</div>
					</v-tab-item>
					<v-tab-item>
						<div class="pa-4">
							<div class="d-flex flex-row align-center justify-space-between my-2 mb-0 px-2">
								<p class="mb-0 font-weight-bold body-2" style="color: #524D4D">Títulos para Informes</p>
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn icon color="grey" class="mr-3"
													v-bind="attrs"
													v-on="on"
													small
													@click="setReportTitle(null)">
											<v-icon>mdi-plus</v-icon>
										</v-btn>
									</template>
									<span>Nuevo título para Informes</span>
								</v-tooltip>
							</div>
							<v-divider class="my-2"></v-divider>
							<v-list class="pt-0" style="max-height: 300px;overflow: scroll;">
								<v-list-item
									v-for="(item, i) in $store.state.reports.companiesReportTitles"
									:key="i"
									class="px-0 py-0"
								>
									<div style="width: 100%">
										<div class="d-flex flex-row px-2 pt-2 justify-space-between">
											<div class="px-4 caption">
												<p class="mb-0 caption font-weight-bold" style="color: #707070;">{{ item.title }}</p>
											</div>
											<div>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn
															icon
															dark
															x-small
															color="warning"
															@click="setReportTitle(item)"
															v-bind="attrs"
															v-on="on"
														>
															<v-icon small dark>mdi-pencil</v-icon>
														</v-btn>
													</template>
													<span>Editar Título</span>
												</v-tooltip>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn
															icon
															dark
															x-small
															color="error"
															@click="deleteBugdetTitle(item)"
															v-bind="attrs"
															v-on="on"
														>
															<v-icon small dark>mdi-delete-outline</v-icon>
														</v-btn>
													</template>
													<span>Eliminar Título</span>
												</v-tooltip>
											</div>
										</div>
									</div>
								</v-list-item>
							</v-list>
						</div>
					</v-tab-item>
				</v-tabs-items>
			</div>
		</div>
	</v-menu>
</template>

<script>
import {removeBudgetPrefix} from '@/helpers/api/budgets'
import {deleteReportTitle} from '@/helpers/api/reports'
import PrefixListingMenu from '@/components/Helpers/Components/PrefixListingMenu'

export default {
	name: 'ContractLeftButtons',
	components: {PrefixListingMenu},
	computed: {
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		showLoading(){
			return this.loading
		},
		companyContractPrefixes(){
			return this.$store.state.budget.companiesBudgetPrefixes.filter((prefix) => {
				return prefix.type == 'contract'
			})
		}
	},
	watch: {
		// selectedCompany(newValue){
		// 	if(newValue){
		// 		this.getConfigs()
		// 	}
		// },
		baseSerial(newValue) {
			if(newValue && newValue > 0 && !this.loading){
				this.onChangeBaseSerial()
			}
		}
	},
	data: () => ({
		contracts_header_columns: null,
		tab: 1,
		loading: false,
		baseSerial: null
	}),
	mounted(){
		this.contracts_header_columns = this.$store.state.contracts.listingColumns
	},
	methods:{
		isNumberKey(event) {
			const charCode = event.which ? event.which : event.keyCode;
			if (charCode < 48 || charCode > 57) {
				event.preventDefault();
			}
		},
		changeColumns(){
			this.$store.commit('contracts/setListingColumns', this.contracts_header_columns)
		},
		setBudgetPrefix(prefix = null){
			let newPrefix = {type: 'contract'}
			if(prefix){
				newPrefix = {
					...newPrefix,
					...prefix,
					...{budget_prefix_id: prefix.id}
				}
			}
			this.$store.commit('budget/setNewBudgetPrefixModalEditing', newPrefix)
      this.$store.commit('budget/setNewBudgetPrefixModal', true)
		},
		async deleteBugdetPrefix(prefix){
			await removeBudgetPrefix({budget_prefix_id: prefix.id})
			this.$store.dispatch('budget/getBudgetPrefixes')
		},
		setReportTitle(title = null){
			this.$store.commit('reports/setNewReportTitleModalEditing', title ? {...title, ...{report_title_id: title.id}}:null)
      this.$store.commit('reports/setNewReportTitleModal', true)
		},
		async deleteBugdetTitle(title){
			await deleteReportTitle({report_title_id: title.id})
			this.$store.dispatch('reports/getReportTitles')
		},
	}
}
</script>